import { useMemo } from "react";
import { Column } from "@tanstack/table-core";
import { useTableContext } from "../../context";
import { renderColumnHeaderAsText } from "../../utils";

export function useFiltersInfo() {
  const table = useTableContext();
  const columnFilters = table?.getState()?.columnFilters;
  const usedFiltersCount = columnFilters?.length || 0;

  const allLeafColumns = table!.getAllLeafColumns();
  const availableColumns = useMemo(
    () => allLeafColumns
      .filter(c => c.getCanFilter())
      .filter(c => c.columnDef.meta!.Filter)
      .map<Column<object> & { headerTitleForSearch: string }>(c => ({
      ...c,
      headerTitleForSearch: renderColumnHeaderAsText(c),
    })),
    [ allLeafColumns ],
  );

  return {
    availableColumns,
    usedFiltersCount,
    columnFilters,
  };
}